// OpenLayersMapWithMarkers.js
import axios from 'axios'
import { Map, View } from 'ol'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import 'ol/ol.css'
import { fromLonLat } from 'ol/proj'
import { OSM, Vector } from 'ol/source'
import { Icon, Stroke, Style } from 'ol/style'
import VectorSource from 'ol/source/Vector'
import React, { useEffect, useState } from 'react'
import StartPoint from '../../../../assets/images/Surveillance/mapIconStartPoint.svg'
import EndPoint from '../../../../assets/images/Surveillance/mapIconEndPoint.svg'
import UserMarker from '../../../../assets/images/Surveillance/mapIconUser.svg'
import MotoMarker from '../../../../assets/images/Surveillance/mapIconMotocycle.svg'
import api from '../../../../services/api'
import { LineString } from 'ol/geom'
import './styles.css'

const MapTracking = ({ occurrence }) => {
  const [userLocation, setUserLocation] = useState()
  const [addressLocation, setAddressLocation] = useState()
  const [employeeLocation, setEmployeeLocation] = useState()
  const [occurrenceLocation, setOccurrenceLocation] = useState()

  const getOccurenceCoordinates = (occurrenceId) => {
    api
      .post('/v1/dashboard/surveillance/tracking', {
        occurrenceId,
      })
      .then((response) => {
        console.log('DETALHE DA OCORRENCIA DADOS:', response.data)
        console.log('ocorrencia', occurrence)

        setUserLocation(response.data.userLocation)
        if (response.data.addressLocation) {
          setAddressLocation(response.data.userLocation)
        } else {
          setAddressLocation({ latitude: 0, longitude: 0 })
        }
        setEmployeeLocation(response.data.employeeLocation)
        setOccurrenceLocation(response.data.occurrenceLocation)
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }

  const getDirections = async (start, end) => {
    const apiKey = '5b3ce3597851110001cf62485355a2b433be4c7e85f41fa887277137'
    const url = 'https://api.openrouteservice.org/v2/directions/driving-car'
    const params = {
      api_key: apiKey,
      start: `${start[0]}, ${start[1]}`,
      end: `${end[0]}, ${end[1]}`,
      language: 'pt',
    }

    try {
      const response = await axios.get(url, {
        params,
      })
      const coordinates = response.data.features[0].geometry.coordinates
      console.log('data google', response.data)
      return coordinates.map((coord) => fromLonLat(coord))
    } catch (error) {
      console.error('Error fetching directions:', error)
      return []
    }
  }

  // Create a line feature based on OpenRouteService API result
  const createTrackFeature = async (startPoint, endPoint, map) => {
    const coordinates = await getDirections(startPoint, endPoint)
    if (coordinates.length > 0) {
      const track = new LineString(coordinates)
      const trackFeature = new Feature(track)
      const trackLayer = new VectorLayer({
        source: new Vector({
          features: [trackFeature],
        }),
        style: new Style({
          stroke: new Stroke({
            color: '#004273',
            width: 2,
          }),
        }),
      })
      map.addLayer(trackLayer)
    } else {
      console.warn('No route found')
    }
  }

  useEffect(() => {
    getOccurenceCoordinates(occurrence.Occurrence.id)
  }, [])

  useEffect(() => {
    // Criar a camada do mapa

    if (occurrenceLocation && addressLocation) {
      const startPoint = [employeeLocation.longitude, employeeLocation.latitude]

      let endPoint: any

      if (occurrence.Occurrence.type === 'Escolta') {
        endPoint = [addressLocation.longitude, addressLocation.latitude]
      } else {
        endPoint = [userLocation.longitude, userLocation.latitude]
      }

      const center = fromLonLat(startPoint)

      const map = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
        view: new View({
          center,
          zoom: 10,
        }),
      })

      const markerStartPoint = [
        {
          coordinates: center,
          icon: StartPoint,
          scale: 1,
        },
      ]

      const markerEndPoint = [
        {
          coordinates: fromLonLat(endPoint),
          icon: EndPoint,
          scale: 1,
        },
      ]

      // Criar a camada de marcadores
      const markerLayer = new VectorLayer({
        source: new VectorSource(),
      })

      // Adicionar marcadores ao mapa
      markerStartPoint.forEach((marker) => {
        const feature = new Feature(new Point(marker.coordinates))
        feature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0, 0],
              src: marker.icon,
              scale: marker.scale,
            }),
          }),
        )
        markerLayer.getSource().addFeature(feature)
      })

      markerEndPoint.forEach((marker) => {
        const feature = new Feature(new Point(marker.coordinates))
        feature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0, 0],
              src: marker.icon,
              scale: marker.scale,
            }),
          }),
        )
        markerLayer.getSource().addFeature(feature)
      })

      if (userLocation) {
        const markerUser = [
          {
            coordinates: fromLonLat([
              userLocation.longitude,
              userLocation.latitude,
            ]),
            icon: UserMarker,
            scale: 1.5,
          },
        ]

        markerUser.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0, 0],
                src: marker.icon,
                scale: marker.scale,
              }),
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })
      }

      if (employeeLocation) {
        const markerEmployee = [
          {
            coordinates: fromLonLat([
              employeeLocation.longitude,
              employeeLocation.latitude,
            ]),
            icon: MotoMarker,
            scale: 3,
          },
        ]

        markerEmployee.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0, 0],
                src: marker.icon,
                scale: marker.scale,
              }),
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })
      }

      // Call the function to create the track feature
      createTrackFeature(startPoint, endPoint, map)

      map.addLayer(markerLayer)

      return () => {
        map.dispose()
      }
    } else if (occurrenceLocation) {
      const center = fromLonLat([
        occurrenceLocation.longitude,
        occurrenceLocation.latitude,
      ])
      const map = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
        view: new View({
          center,
          zoom: 10,
        }),
      })
      // Adicionar marcador para occurrenceLocation
      const markerOccurrence = [
        {
          coordinates: center,
          icon: StartPoint, // Use um ícone apropriado, pode ser StartPoint ou um específico para o ponto de ocorrência
          scale: 1.5,
        },
      ]
      const markerLayer = new VectorLayer({
        source: new VectorSource(),
      })
      markerOccurrence.forEach((marker) => {
        const feature = new Feature(new Point(marker.coordinates))
        feature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 1],
              src: marker.icon,
              scale: marker.scale,
            }),
          }),
        )
        markerLayer.getSource().addFeature(feature)
      })
      map.addLayer(markerLayer)
      return () => {
        map.dispose()
      }
    }
  }, [
    occurrence,
    userLocation,
    addressLocation,
    employeeLocation,
    occurrenceLocation,
  ])

  return <div id="map" style={{ width: '100%', height: '300px' }}></div>
}

export default MapTracking
